import { Card, CardHeader, CardBody, CardFooter, Button, Container, Row, Col, CardTitle } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import "../Styles/LoginStyle.css";


export const RequiredLogin = () => {
  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate('/');
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center align-items-center " style={{ height: '100%',width:'100%' }}>
        <Col md="6">
          <Card>
          <CardHeader className="card_header text-white">
            <CardTitle tag="h4" className="text-center">Voce precisa estar logado</CardTitle>
          </CardHeader>
            <CardBody>
              <p>
                Você precisa estar logado para acessar esta página. Clique no botão abaixo para retornar à página inicial.
              </p>
              <Button className="button_adjust" color="primary" onClick={handleNavigateHome}>
                Voltar para a Página Inicial
              </Button>
            </CardBody>
            <CardFooter className="card_footer text-white text-center">
            ConCredito. ©2025
          </CardFooter>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};